import type { RpcMethodParameters } from '@scayle/storefront-nuxt'
import type { RpcOptions } from '../types/rpc'

type Options = Partial<{
  params: MaybeRefOrGetter<RpcMethodParameters<'listCategories'>>
  options: RpcOptions
  key: string
}>

export default ({
  key = 'useListCategories',
  params,
  options,
}: Options = {}) => {
  const { data, refresh, status } = useRpc(
    'listCategories',
    key,
    params,
    options,
  )

  return { data, refresh, status }
}
